
import React, { useState, useEffect, useRef } from "react";
import "../../assets/css/reservation.css";
import { useTranslation } from "react-i18next";
import Modal from "react-modal"; // Importez le composant Modal

// Définissez les styles par défaut pour la modal
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: '#f8f9fa',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
    },
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: 1000,
    },
};

Modal.setAppElement('#root'); // Assurez-vous que '#root' correspond à l'ID de votre élément racine

export default function ServiceRequestForm() {
    const { t } = useTranslation("reservation");
    const serviceRequestSectionRef = useRef(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [formData, setFormData] = useState({
        serviceType: "",
        eventType: "",
        menuType: "",
        dietaryRestrictions: [],
        guestCount: 1,
        meatType: "",
        setupLocation: "",
        spaceDescription: "",
        date: "",
        lieuEvenement: "", // Nouveau champ pour le lieu spécifique
        villeEvenement: "", // Nouveau champ pour la ville
        setupLocation: "",
        time: "",
        budget: "",
        additionalRequests: "",
        name: "",
        email: "",
        phone: "",
    });
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const [modalIsError, setModalIsError] = useState(false);
    const API_BASE_URL = process.env.REACT_APP_API_URL;


    const openModal = (message, isError = false) => {
        setModalMessage(message);
        setModalIsError(isError);
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
        if (!modalIsError && modalMessage === t("successMessage")) {
            setFormData({
                serviceType: "",
                eventType: "",
                menuType: "",
                dietaryRestrictions: [],
                guestCount: 1,
                meatType: "",
                setupLocation: "",
                spaceDescription: "",
                date: "",
                time: "",
                budget: "",
                additionalRequests: "",
                name: "",
                email: "",
                phone: "",
            });
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prevData) => {
            if (type === "checkbox") {
                return {
                    ...prevData,
                    dietaryRestrictions: checked
                        ? [...prevData.dietaryRestrictions, value]
                        : prevData.dietaryRestrictions.filter(
                              (item) => item !== value
                          ),
                };
            } else {
                return {
                    ...prevData,
                    [name]: value,
                };
            }
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(`${API_BASE_URL}/api/reservations`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                console.log("Demande de réservation soumise avec succès!");
                openModal(t("successMessage"));
            } else {
                const errorData = await response.json();
                console.error(
                    "Erreur lors de la soumission de la réservation:",
                    errorData
                );
                if (response.status === 409 && errorData.message) {
                    openModal(errorData.message, true); // Afficher le message spécifique du backend
                } else {
                    openModal(t("errorMessage"), true); // Afficher un message d'erreur générique
                }
            }
        } catch (error) {
            console.error(
                "Erreur réseau lors de la soumission de la réservation:",
                error
            );
            openModal(t("networkErrorMessage"), true);
        }
    };
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsLoaded(true);
                        observer.unobserve(serviceRequestSectionRef.current);
                    }
                });
            },
            {
                root: null,
                threshold: 0.2,
            }
        );

        if (serviceRequestSectionRef.current) {
            observer.observe(serviceRequestSectionRef.current);
        }

        return () => {
            if (serviceRequestSectionRef.current) {
                observer.unobserve(serviceRequestSectionRef.current);
            }
        };
    }, []);

    return (
        <section
            id="ServiceRequest"
            ref={serviceRequestSectionRef}
            className={isLoaded ? "loaded" : ""}
        >
            <div
                className={`service-request-container ${
                    isLoaded ? "loaded" : ""
                }`}
            >
                <h2 className="service-request-title">{t("title")}</h2>
                <form onSubmit={handleSubmit} className="service-request-form">
                    <div className="form-group">
                        <label htmlFor="serviceType">{t("serviceType")}</label>
                        <select
                            id="serviceType"
                            name="serviceType"
                            value={formData.serviceType}
                            onChange={handleChange}
                            required
                        >
                            <option value="">{t("selectService")}</option>
                            <option value="FOOT">{t("foodAndDrinks")}</option>
                            <option value="SMOKE">{t("smokehouse")}</option>
                            <option value="SETUP">{t("setup")}</option>
                        </select>
                    </div>

                    {formData.serviceType === "FOOT" && (
                        <>
                            <div className="form-group">
                                <label htmlFor="eventType">
                                    {t("eventType")}
                                </label>
                                <input
                                    type="text"
                                    id="eventType"
                                    name="eventType"
                                    value={formData.eventType}
                                    onChange={handleChange}
                                    placeholder={t("eventTypePlaceholder")}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="guestCount">
                                    {t("guestCount")}
                                </label>
                                <input
                                    type="number"
                                    id="guestCount"
                                    name="guestCount"
                                    value={formData.guestCount}
                                    onChange={handleChange}
                                    min="1"
                                    required
                                />
                            </div>
                            {/* ... autres champs pour le service A ... */}
                        </>
                    )}

                    {formData.serviceType === "SMOKE" && (
                        <div className="form-group">
                            <label htmlFor="meatType">{t("meatType")}</label>
                            <input
                                type="text"
                                id="meatType"
                                name="meatType"
                                value={formData.meatType}
                                onChange={handleChange}
                                placeholder={t("meatTypePlaceholder")}
                            />
                            <div className="form-group">
                                <label htmlFor="guestCount">
                                    {t("guestCount")}
                                </label>
                                <input
                                    type="number"
                                    id="guestCount"
                                    name="guestCount"
                                    value={formData.guestCount}
                                    onChange={handleChange}
                                    min="1"
                                    required
                                />
                            </div>
                        </div>
                    )}

                    {formData.serviceType === "SETUP" && (
                        <>
                            <div className="form-group">
                                <label htmlFor="setupLocation">
                                    {t("setupLocation")}
                                </label>
                                <select
                                    id="setupLocation"
                                    name="setupLocation"
                                    value={formData.setupLocation}
                                    onChange={handleChange}
                                >
                                    <option value="">
                                        {t("selectLocation")}
                                    </option>
                                    <option value="indoor">
                                        {t("indoor")}
                                    </option>
                                    <option value="outdoor">
                                        {t("outdoor")}
                                    </option>
                                </select>
                                <div className="form-group">
                                    <label htmlFor="guestCount">
                                        {t("guestCount")}
                                    </label>
                                    <input
                                        type="number"
                                        id="guestCount"
                                        name="guestCount"
                                        value={formData.guestCount}
                                        onChange={handleChange}
                                        min="1"
                                        required
                                    />
                                </div>
                            </div>
                            {/* ... autres champs pour le service C ... */}
                        </>
                    )}

                    <div className="form-group">
                        <label htmlFor="date">{t("date")}</label>
                        <input
                            type="date"
                            id="date"
                            name="date"
                            value={formData.date}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="time">{t("time")}</label>
                        <input
                            type="time"
                            id="time"
                            name="time"
                            value={formData.time}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="lieuEvenement">
                            {t("lieuEvenement")}
                        </label>
                        <input
                            type="text"
                            id="lieuEvenement"
                            name="lieuEvenement"
                            value={formData.lieuEvenement}
                            onChange={handleChange}
                            placeholder={t("lieuEvenementPlaceholder")}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="villeEvenement">
                            {t("villeEvenement")}
                        </label>
                        <input
                            type="text"
                            id="villeEvenement"
                            name="villeEvenement"
                            value={formData.villeEvenement}
                            onChange={handleChange}
                            placeholder={t("villeEvenementPlaceholder")}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="budget">{t("budget")}</label>
                        <input
                            type="text"
                            id="budget"
                            name="budget"
                            value={formData.budget}
                            onChange={handleChange}
                            placeholder={t("budgetPlaceholder")}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="additionalRequests">
                            {t("additionalRequests")}
                        </label>
                        <textarea
                            id="additionalRequests"
                            name="additionalRequests"
                            rows="4"
                            value={formData.additionalRequests}
                            onChange={handleChange}
                            placeholder={t("additionalRequestsPlaceholder")}
                        ></textarea>
                    </div>
                    <div className="form-group">
                        <label htmlFor="name">{t("name")}</label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="email">{t("email")}</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="phone">{t("phone")}</label>
                        <input
                            type="tel"
                            id="phone"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                        />
                    </div>
                    <button type="submit" className="submit-button">
                        {t("submit")}
                    </button>
                </form>

                {/* Composant Modal */}
                <Modal
                    isOpen={modalIsOpen}
                    onRequestClose={closeModal}
                    style={customStyles}
                    contentLabel="Reservation Status"
                >
                    <h2>
                        {modalIsError ? t("errorTitle") : t("successTitle")}
                    </h2>
                    <p>{modalMessage}</p>
                    <button onClick={closeModal} className="submit-button">
                        {t("close")}
                    </button>
                </Modal>
            </div>
        </section>
    );
}